<template>
    <div>
        <div class="form-container" id="form-step-3">
            <fieldset>
                <div class="row">
                </div>
                <div class="row">
                    <div class="columns small-12 lp">
                        <div  class="terms" v-html="termsContent"></div> <br>
                        <div v-if="isRayban2">
                            <label for="termsaccept1" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item1" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept1" name="AcceptTerm1" v-validate="'required'" type="checkbox" class="termscheck"> 
                                In case of a user-supplied frame to come
                                <ul style="margin-left: 50px">
                                    <li>I understand I have 60 days after redemption to send in frames before the evaluation product will be canceled, as stipulated in the terms of service. </li>
                                    <li>I understand that Essilor is not responsible for lost, postage-due, misdirected, or damaged frames, as stipulated in the terms of service.</li>
                                </ul>
                            </label>
                            <label for="termsaccept2" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item2" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept2" name="AcceptTerm2" v-validate="'required'" type="checkbox" class="termscheck"> 
                                I understand the evaluation product order will be returned within 2-4 weeks from receipt of the order (4-6 weeks after receipt of frames for user-supplied frames) , as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept3" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item3" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept3" name="AcceptTerm3" v-validate="'required'" type="checkbox" class="termscheck"> 
                                A replacement on evaluation product orders are only available within 30 days of shipping from the lab as stipulated in the terms of service
                            </label>
                            <label for="termsaccept4" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item4" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept4" name="AcceptTerm4" v-validate="'required'" type="checkbox" class="termscheck"> 
                                I understand and agree to all terms of service. 
                            </label>
                        </div>
                        <div v-else>
                            <label for="termsaccept10" class="termslabel lp" v-if="newProductEPName"> 
                                <input v-model="acceptedTerms.item10" v-on:change="changeAcceptedTerms()" id="termsaccept10" name="AcceptTerm10" v-validate="'required'" type="checkbox" class="termscheck"> 
                                <strong> I acknowledge and affirm, I have not previously evaluated {{ newProductEPName }}.</strong>
                            </label>
                            <label for="termsaccept9" class="termslabel lp" v-if="isCrizalNaturalLook"> 
                                <input v-model="acceptedTerms.item9" v-on:change="changeAcceptedTerms()" id="termsaccept9" name="AcceptTerm9" v-validate="'required'" type="checkbox" class="termscheck"> 
                                <strong>I acknowledge and affirm, I have not previously evaluated Crizal Natural Look.</strong>
                            </label>
                            <label for="termsaccept5" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item5" v-on:change="changeAcceptedTerms()" id="termsaccept5" name="AcceptTerm5" v-validate="'required'" type="checkbox" class="termscheck"> <strong> I acknowledge and affirm, I am presently in a patient-facing role within the eyecare industry, which may include positions such as an Optician, Optometrist, Ophthalmologist, Optical Technician, or Eyewear Consultant. </strong>
                            </label>
                            <label for="termsaccept7" class="termslabel lp" v-if="isVariluxXr"> 
                                <input v-model="acceptedTerms.item7" v-on:change="changeAcceptedTerms()" id="termsaccept7" name="AcceptTerm7" v-validate="'required'" type="checkbox" class="termscheck"> <strong> I certify that I have not tried Varilux<sup>&reg;</sup> XR series<sup>&trade;</sup> evaluation product before. If I order multiple Varilux<sup>&reg;</sup> XR series<sup>&trade;</sup> Evaluation products, Essilor has rights to bill my practice with full wholesale cost of evaluation product. </strong>
                            </label>
                            <label for="termsaccept8" class="termslabel lp" v-if="isLegacy"> 
                                <input v-model="acceptedTerms.item8" v-on:change="changeAcceptedTerms()" id="termsaccept8" name="AcceptTerm8" v-validate="'required'" type="checkbox" class="termscheck"> <strong> I certify that I have not evaluated this product before. If I order Evaluation Product that doesn't not meet terms and conditions, Essilor has right to bill my practice with full wholesale price</strong>
                            </label>
                            <label for="termsaccept1" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item1" v-on:change="changeAcceptedTerms()" id="termsaccept1" name="AcceptTerm1" v-validate="'required'" type="checkbox" class="termscheck"> In case of a user supplied frame to come, I understand that Essilor is not responsible for lost, postage-due, misdirected, or damaged frames, as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept2" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item2" v-on:change="changeAcceptedTerms()" id="termsaccept2" name="AcceptTerm2" v-validate="'required'" type="checkbox" class="termscheck"> I understand the evaluation product order will be returned within 4-6 weeks from receipt of the frames, as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept3" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item3" v-on:change="changeAcceptedTerms()" id="termsaccept3" name="AcceptTerm3" v-validate="'required'" type="checkbox" class="termscheck"> In case of a user supplied frame to come, I understand I have 60 days after redemption to send in frames before the evaluation product will be canceled, as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept4" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item4" v-on:change="changeAcceptedTerms()" id="termsaccept4" name="AcceptTerm4" v-validate="'required'" type="checkbox" class="termscheck"> A replacement on evaluation product orders are only available within 30 days of shipping from the lab as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept6" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item6" v-on:change="changeAcceptedTerms()" id="termsaccept6" name="AcceptTerm6" v-validate="'required'" type="checkbox" class="termscheck"> I understand and agree to all terms of service.
                            </label>
                        </div>
                    </div>
                    <div :class="{'error': !acceptedAllTerms }">
                        <p class="error" v-if="!acceptedAllTerms">You must accept the terms of service</p>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>
<script>
export default {
    props: ['sampleobject', 'terms-content'],
    inject: ['$validator'],
    data() {
        return {
            acceptedTerms: {
                item1: false,
                item2: false,
                item3: false,
                item4: false,
                item5: false,
                item6: false,
                item7: false,
                item8: false,
                item9: false,
                item10: false,
            },
            acceptedAllTerms: false,
            isRayban2: false,
            isVariluxXr: false,
            isLegacy: false,
            isCrizal: false,
            newProductEPName: null
        }
    },
    created() {
        var page = this.$route.name; // order_review
        var preCouponText = this.$route.params.couponCode.toString().split('-')[0];
        var isRayban2 = preCouponText.includes("RBAN2") && page === 'order_review';
        this.isRayban2 = isRayban2;
        this.isVariluxXr = preCouponText.includes("VXXR")
        this.isLegacy = preCouponText.includes("L230")
        this.isCrizalNaturalLook = preCouponText.includes("CNL")

        // New Product EP: detect from termsPageName and set dynamic product name
        const newProductEPMap = {
            'vxshift.terms.html':                       'Varilux Shift',
            'vximmersiamid.terms.html':                 'Varilux Immersia Mid',
            'vximmersiaroom.terms.html':                'Varilux Immersia Room',
            'variluxphysioextensee.terms.html':         'Varilux Physio Extensee',
            'variluxphysioextenseeclassic.terms.html':  'Varilux Physio Extensee Classic Edition',
            'variluxphysioextenseetrack.terms.html':    'Varilux Physio Extensee Track',
            'variluxcomfortmax.terms.html':             'Varilux Comfort Max',
            'variluxcomfortmax2.terms.html':            'Varilux Comfort Max',
            'variluxidesign.terms.html':                'Varilux iDesign',
            'variluxliberty.terms.html':                'Varilux Liberty',
            'xtractivenewgeneration.terms.html':        'Transitions XTRActive New Generation',
            'xtractivepolarized.terms.html':            'Transitions XTRActive Polarized',
        };
        const termsPage = (this.sampleobject && this.sampleobject.termsPageName) || '';
        this.newProductEPName = newProductEPMap[termsPage] || null;
    },
    methods: {
        changeAcceptedTerms(program = '') {
            this.acceptedAllTerms = this.acceptedTerms.item1 && this.acceptedTerms.item2 && this.acceptedTerms.item3 && this.acceptedTerms.item4 && this.acceptedTerms.item5 && this.acceptedTerms.item6 && this.acceptedTerms.item9;

            // Rayban2 only
            if (program === 'rb2') {
                this.acceptedAllTerms = this.acceptedTerms.item1 && this.acceptedTerms.item2 && this.acceptedTerms.item3 && this.acceptedTerms.item4;
            }

            // Varilux XRs
            if (this.isVariluxXr) {
                this.acceptedAllTerms = this.acceptedAllTerms && this.acceptedTerms.item7;
            }

            // Legacy
            if (this.isLegacy) {
                this.acceptedAllTerms = this.acceptedAllTerms && this.acceptedTerms.item8;
            }

            // Crizal Natural Look
            if (this.isCrizalNaturalLook) {
                this.acceptedAllTerms = this.acceptedAllTerms && this.acceptedTerms.item9;
            }

            // New Product EP
            if (this.newProductEPName) {
                this.acceptedAllTerms = this.acceptedAllTerms && this.acceptedTerms.item10;
            }
            this.sampleobject.acceptedTerms = this.acceptedAllTerms;
        }
    }
}
</script>

<style>
.terms {
    height: 200px;
    overflow-y: scroll;
    border: 1px solid black;
    margin: auto;
    padding: 32px;
}

.terms p, .terms ul li {
    font-size:smaller;
}

.termslabel {
    font-size: 12pt;
}

.termscheck {
    font-size: 12pt;
}
</style>
